import { Component, OnInit, Input } from '@angular/core';
import { Course } from 'lms-api';
import { UserCourseDataService } from 'lms-api';

@Component({
  selector: 'app-course-carousel',
  templateUrl: './course-carousel.component.html',
  styleUrls: ['./course-carousel.component.scss']
})
export class CourseCarouselComponent implements OnInit {
  @Input() selector;
  public courses: Course[];
  public title: string;

  constructor(private ucdService: UserCourseDataService) { 
    this.courses = [];
  }

  ngOnInit() {
    this.ucdService.Carousels.subscribe(carousels => {
      let carousel = carousels.find(c => c.selector == this.selector);
      if (carousel) {
        this.title = carousel.title;
        this.courses = carousel.courses;
      } else if(atatus) {
        atatus.notify(new Error("Missing carousel: " + this.selector));
      }
    });
  }

}
